<style src="./SearchField.scss" lang="scss"></style>

<template lang="pug">
  .search-field(
    :class='{ "is-focused": focused, "is-loading": loading }'
    v-click-outside='() => setFocus(false)'
  )
    .search-field__control
      input.search-field__input(
        :placeholder='focused ? null : $l10n("SEARCH")'
        name='q'
        autocomplete='off'
        v-model='keyword'
        ref='input'
        inputmode='search'
        @focus='setFocus(true)'
        @input='inputHandler()'
        v-shortkey.avoid
      )
      .search-field__icon
        Icon(
          name='search'
        )
    ul.search-field__results(
      v-if='checkResultsVisible("list")'
    )
      li.search-field__result-group(
        v-for='group in serializedResults'
        :key='group.title'
      )
        h4.search-field__group-title {{ group.title }}
        ul.search-field__result-list
          li.search-field__result-item(
            v-for='item in group.items'
            :key='item.id'
            @click='clear'
          )
            router-link.search-field__result-link(
              :to='`/${group.alias}/${item.id}`'
            ) {{ item.title }}
    .search-field__results(
      v-if='checkResultsVisible("empty")'
    ) {{ $l10n('NOT_FOUNDED') }}

</template>

<script>
import Icon from "@/components/Icon/Icon";

import Helpers from "@/services/helpers";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SearchField",
  props: {
    autofocus: Boolean
  },
  data() {
    return {
      keyword: "",
      loading: false,
      focused: false,
      showResults: false,
      debouncedFetchResults: null
    };
  },
  components: {
    Icon
  },
  computed: {
    ...mapGetters({
      results: "search/results"
    }),
    serializedResults() {
      return this.results.global
        ? Object.keys(this.results.global)
            .filter(key => this.results.global[key].length)
            .map(key => {
              return {
                title: this.$l10n(key.toUpperCase()),
                alias: key,
                items: this.results.global[key]
              };
            })
        : [];
    }
  },
  methods: {
    ...mapActions({
      fetchResults: "search/global",
      clearResults: "search/clear"
    }),
    clear() {
      setTimeout(() => {
        this.clearResults("global");
        this.keyword = "";
        this.focused = false;
      });
    },
    setFocus(state) {
      if (state) {
        this.focused = true;
      } else {
        setTimeout(() => {
          this.focused = false;
        }, 400);
      }
    },
    inputHandler() {
      this.showResults = false;
      this.debouncedFetchResults();
    },
    checkResultsVisible(type) {
      switch (type) {
        case "list":
          return (
            this.serializedResults.length && this.focused && this.showResults
          );
        case "empty":
          return (
            this.keyword &&
            this.showResults &&
            this.focused &&
            !this.serializedResults.length
          );
      }
    }
  },
  created() {
    this.debouncedFetchResults = Helpers.debounce(() => {
      const timer = setTimeout(() => {
        this.loading = true;
      }, 600);

      this.fetchResults(this.keyword).then(() => {
        clearTimeout(timer);
        setTimeout(() => {
          this.loading = false;
          this.showResults = true;
        }, 400);
      });
    }, 200);
  },
  mounted() {
    if (this.autofocus) {
      this.$refs.input.focus();
    }
  }
};
</script>
